'use client';

import { useScreenName } from '@tuic/web-compositions/hooks/use-screen-name';
import { Image } from '@tuic/web-compositions/shared/Image';
import { getResponsiveValue } from '@tuic/web-compositions/utils/responsive-property';
import { useMemo } from 'react';

import type { ImageProps } from '@tuic/web-compositions/shared/Image';
import type { ResponsiveValue } from '@tuic/web-compositions/utils/responsive-property';
import type { FC } from 'react';

export type ResponsiveImageProps = {
  responsiveProps: ResponsiveValue<ImageProps>;
} & Omit<ImageProps, 'src' | 'alt'>;

export const ResponsiveImage: FC<ResponsiveImageProps> = ({
  responsiveProps,
  ...rest
}) => {
  const screenName = useScreenName();

  const imageProps = useMemo(() => {
    const defaultValue = Array.isArray(responsiveProps)
      ? responsiveProps[0]
      : responsiveProps;

    return getResponsiveValue(responsiveProps, defaultValue, screenName);
  }, [screenName, responsiveProps]);

  return <Image {...imageProps} {...rest} />;
};
